export const borrowerDefaults = {
  personalGuarantor: true,
};

export const isBorrowerPersonGuarantor = (
  pctOwnership: number
) => {
  return !!(pctOwnership && !isNaN(pctOwnership) && pctOwnership > 20);
};

export const formatBorrowerExperience = (exp) => {
  if (exp == '6') {
    return '5+'
  }
  return exp;
}
export type BorrowerIdentityDataItem = {
  idType?: string;
  idNumber?: string;
  expirationDate?: string;
  state?: string;
  nationality?: string;
};

const PASSPORT_ID_TYPES = ['US_PASSPORT', 'NON_US_PASSPORT'];

export const getBorrowerDriverLicense = (borrower: { identityData?: BorrowerIdentityDataItem[] }): BorrowerIdentityDataItem =>
  (borrower?.identityData ?? []).find(item => item.idType === 'DRIVER_LICENSE') ?? {};

export const getBorrowerPassport = (borrower: { identityData?: BorrowerIdentityDataItem[] }): BorrowerIdentityDataItem =>
  (borrower?.identityData ?? []).find(item => PASSPORT_ID_TYPES.includes(item.idType)) ?? {};
